export default [
  {
    path: "/yearReport",
    name: "yearReport",
    meta: {
      title: "猎上网-年度报告",
    },
    component: () => import("./index.vue")
  },
  {
    path: "/yearMusic",
    name: "yearMusic",
    meta: {
      title: "猎上网-年度报告",
    },
    component: () => import("./music.vue")
  }
];
